import React from 'react';
import { useMapEditor } from '../../../../contexts/MapEditorContext';
import { DragNumberInput } from '../../../controls/ScrollDragNumberInput';
import { PanelSectionWrapper } from '../PanelSectionWrapper';
import { ShapeSectionOptions } from '../ShapePanel';

export const CommonSizePanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditor();
  const shape = shapes[0];

  const handleWidthChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { width: Number.parseInt(String(value)) });
    });
  };

  const handleHeightChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { height: Number.parseInt(String(value)) });
    });
  };

  return (
    <PanelSectionWrapper title={'Size'}>
      <div className={'flex gap-2'}>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Width</div>
          <DragNumberInput
            size={'sm'}
            value={shape.width}
            onChange={handleWidthChangeValue}
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Height</div>
          <DragNumberInput
            size={'sm'}
            value={shape.height}
            onChange={handleHeightChangeValue}
          />
        </div>
      </div>
    </PanelSectionWrapper>
  );
};
